'use client';

import { ChatInput } from './components/chat-input';
import {
  Conversation,
  ConversationContent,
  ConversationScrollButton,
} from './components/elements/conversation';
import { Loader } from './components/elements/loader';
import { MessageList } from './components/message-list';
import { Overview } from './components/overview';
import { useChatContext } from './context/chat-context';

export function Chat() {
  const { messages, status, regenerate, handleSubmit } = useChatContext();

  console.log(messages, 'messages');

  return (
    <div className="flex mx-auto bg-background w-full md:max-w-3xl flex-col h-[calc(100vh-80px)] min-h-full [&_ul]:ml-2 [&_ul]:p-0 [&_ol]:ml-1 [&_ol]:p-0 [&_li]:m-1 [&_li]:p-0 [&_h1]:text-xl [&_h2]:text-lg [&_h3]:text-base [&_h4]:text-base [&_h5]:text-base [&_h6]:text-base">
      <Conversation className="flex-1 min-h-0 custom-scrollbar pl-3">
        <ConversationContent className="pb-4 custom-scrollbar">
          {messages.length === 0 ? (
            <Overview />
          ) : (
            <MessageList messages={messages} status={status} onRegenerate={regenerate} />
          )}
          {status === 'submitted' && <Loader />}
        </ConversationContent>
        <ConversationScrollButton />
      </Conversation>

      <ChatInput onSubmit={handleSubmit} status={status} />
    </div>
  );
}
